<template>
  <div>
    <div v-if="!slug">
      <section>
        <h3>Canais</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'email' },
            }"
          >
            <div class="box-content">
              <h3>E-MAIL (SMTP)</h3>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'whatsapp' },
            }"
          >
            <div class="box-content">
              <h3>Whatsapp</h3>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'sms'},
            }"
          >
            <div class="box-content">
              <h3>SMS</h3>
            </div>
          </router-link>
        </div>
      </section>
      <section class="margin-top-l">
        <h3>Contatos</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'open-api' },
            }"
          >
            <div class="box-content">
              <h3>OPEN API</h3>
            </div>
          </router-link>
        </div>
      </section>
      <section class="margin-top-l">
        <h3>I.A</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'eleven-labs' },
            }"
          >
            <div class="box-content">
              <h3>Eleven Labs</h3>
            </div>
          </router-link>
        </div>
      </section>
      <section class="margin-top-l">
        <h3>KANBAN</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'trello' },
            }"
          >
            <div class="box-content">
              <h3>TRELLO</h3>
            </div>
          </router-link>
        </div>
      </section>
      <section class="margin-top-l">
        <h3>Vendas</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'hotmart' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/hotmart.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'inlead' },
            }"
          >
            <div class="box-content">
              <img width="130" src="@/assets/img/inter/inlead.png"/>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'kiwify' },
            }"
          >
            <div class="box-content">
              <img width="130" src="@/assets/img/inter/kiwify.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'shopify' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/shopify.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'perfectpay' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/perfectpay.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'yampi' },
            }"
          >
            <div class="box-content">
              <img width="130" src="@/assets/img/inter/yampi.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'payt' },
            }"
          >
            <div class="box-content">
              <img width="70" src="@/assets/img/inter/payt.png"/>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'braip' },
            }"
          >
            <div class="box-content">
              <img width="110" src="@/assets/img/inter/braip.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'doppus' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/doppus.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'cartpanda' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/cartpanda.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'appmax' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/appmax.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'eduzz' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/eduzz.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'monetizze' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/monetizze.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'evermart' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/evermart.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'greenn' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/greenn.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'blitzpay' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/blitzpay.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'pagarme' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/pagarme.png"/>
            </div>
          </router-link>
        </div>
      </section>

      <section class="flex center-txt margin-top-l">
        <p>
          Não encontrou a integração que precisa? Envie sua sugestão para:
          <a href="mailto:contato@123mail.com.br"
            >contato@123mail.com.br</a
          >
        </p>
      </section>
    </div>
    <div v-else>
      <!-- Canais -->
      <email v-if="slug === 'email'"></email>
      <whatsapp v-if="slug === 'whatsapp'"></whatsapp>
      <sms v-if="slug === 'sms'"></sms>

      <!-- api -->
      <open-api v-if="slug === 'open-api'"></open-api>

      <!-- kanban -->
      <trello v-if="slug === 'trello'"></trello>

      <!-- ia -->
      <eleven-labs v-if="slug === 'eleven-labs'"></eleven-labs>
      

      <!-- Marketing -->
      <facebook-ads v-if="slug === 'facebook-ads'"></facebook-ads>
      <google-ads v-if="slug === 'google-ads'"></google-ads>
      <tiktok-ads v-if="slug === 'tiktok-ads'"></tiktok-ads>
      <!-- Sale -->
      <hotmart v-if="slug === 'hotmart'"></hotmart>
      <kiwify v-if="slug === 'kiwify'"></kiwify>
      <inlead v-if="slug === 'inlead'"></inlead>
      <shopify v-if="slug === 'shopify'"></shopify>
      <eduzz v-if="slug === 'eduzz'"></eduzz>
      <braip v-if="slug === 'braip'"></braip>
      <doppus v-if="slug === 'doppus'"></doppus>
      <cart-panda v-if="slug === 'cartpanda'"></cart-panda>
      <perfect-pay v-if="slug === 'perfectpay'"></perfect-pay>
      <yampi v-if="slug === 'yampi'"></yampi>
      <monetizze v-if="slug === 'monetizze'"></monetizze>
      <evermart v-if="slug === 'evermart'"></evermart>
      <greenn v-if="slug === 'greenn'"></greenn>
      <blitzpay v-if="slug === 'blitzpay'"></blitzpay>
      <pagarme v-if="slug === 'pagarme'"></pagarme>
      <app-max v-if="slug === 'appmax'"></app-max>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Email from "./integrations/Email";
import Whatsapp from "./integrations/Whatsapp";
import Sms from "./integrations/Sms";
import OpenApi from "./integrations/OpenApi";

import Trello from "./integrations/Trello";

import ElevenLabs from "./integrations/ElevenLabs";

import FacebookAds from "./integrations/FacebookAds";
import GoogleAds from "./integrations/GoogleAds";
import TiktokAds from "./integrations/TiktokAds";

import Hotmart from "./integrations/Hotmart";
import Inlead from "./integrations/Inlead";
import Kiwify from "./integrations/Kiwify";
import Shopify from "./integrations/Shopify";
import Eduzz from "./integrations/Eduzz";
import PerfectPay from "./integrations/PerfectPay";
import Yampi from "./integrations/Yampi";
import Braip from "./integrations/Braip";
import Doppus from "./integrations/Doppus";
import Monetizze from "./integrations/Monetizze";
import Evermart from "./integrations/Evermart";
import Greenn from "./integrations/Greenn";
import Blitzpay from "./integrations/Blitzpay";
import Pagarme from "./integrations/Pagarme";
import CartPanda from "./integrations/CartPanda";
import AppMax from "./integrations/AppMax";

export default {
  name: "config-integration",
  components: {
    FacebookAds,
    GoogleAds,
    TiktokAds,
    Hotmart,
    Kiwify,
    Shopify,
    Eduzz,
    Monetizze,
    Evermart,
    Greenn,
    Blitzpay,
    Pagarme,
    PerfectPay,
    Yampi,
    Braip,
    Doppus,
    CartPanda,
    AppMax,
    Email,
    Whatsapp,
    Sms,
    OpenApi,
    Trello,
    ElevenLabs,
    Inlead
  },
  props: ["slug"],
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-width: 300px;
  min-height: 120px;
  margin-top: 16px;
  margin-left: 0px !important;
  margin-right: 20px;

  .box-content {
    cursor: pointer;
  }

  a {
    width: 100%;
    height: 100%;
  }
}

.disabled-box {
  background: #e8e8e8;
  > a {
    cursor: none;
  }
}

.tag {
  background: var(--primary);
  color: #fff;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
}
</style>
